import PrivateImage from "../component/PrivateImage";
import { API_BASE_URL } from "../Api/baseurl";
import React, { useRef, useEffect, useState } from "react";
import * as XLSX from "xlsx";
import Select from "react-select";
import {
  Container,
  Row,
  Col,
  Card,
  ListGroup,
  Modal,
  Button,
  Form,
  Badge,
} from "react-bootstrap";
import { ChevronUp, ChevronDown } from "react-bootstrap-icons";
import Barcode from "react-barcode";
import { Fire } from "react-bootstrap-icons";
import Header from "../component/Header";
import NavBar from "../component/NavBar";
import Footer from "../component/Footer";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSpecificReport } from "./../Redux/actions/Reportaction";
import { CreateFeedBack } from "./../Redux/actions/Useraction";
import DicomThumbnail from "../component/Dicomthumbnail";
import notify from "../Hook/useNotification";
import { useTranslation } from "react-i18next";
const PatientReport = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { patientId, reportId } = useParams();
  const userFromStorage = JSON.parse(localStorage.getItem("user"));
  console.log(userFromStorage);
  const [showRightEyeFeedback, setShowRightEyeFeedback] = useState(false);
  const [, setloading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [diagnosisOptions, setDiagnosisOptions] = useState([]);
  const [feedbackSent, setFeedbackSent] = useState(false);
  const [showLeftEyeFeedback, setShowLeftEyeFeedback] = useState(false);
  const [selectedHeatmap, setSelectedHeatmap] = useState(null);
  const [rightEyeFeedback, setRightEyeFeedback] = useState({
    aiPredictionCorrect: "",
    comment: "",
    diagnosis: "",
    recommendedAction: "",
  });

  const [leftEyeFeedback, setLeftEyeFeedback] = useState({
    aiPredictionCorrect: "",
    comment: "",
    diagnosis: "",
    recommendedAction: "",
  });

  useEffect(() => {
    if (patientId && reportId) {
      dispatch(getSpecificReport(patientId, reportId));
    }
  }, [dispatch, patientId, reportId]);

  useEffect(() => {
    const fetchDiagnosisData = async () => {
      const response = await fetch("/ICD10_Final_Subcodes.xlsx"); // الملف موجود في public
      const arrayBuffer = await response.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: "buffer" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(sheet);

      const options = data.map((item) => ({
        label: `${item["definition"]} (${item["sub-code"]})`, // تعديل بناءً على الأعمدة الموجودة في الشيت
        value: item["definition"],
      }));

      setDiagnosisOptions(options);
    };

    fetchDiagnosisData();
  }, []);

  // Filter feedback by the logged-in doctor's ID
  const ReportData = useSelector((state) => state.allreport.specificreport);
  const Report = ReportData.data || [];
  console.log(Report);

  const opticianName = `${Report?.optician?.firstName} ${Report?.optician?.lastName}`;

  const reportRef = useRef();

  const handlePrint = () => {
    window.print();
  };

  const displayValue = (value) => {
    return value !== undefined && value !== null && value !== "" ? (
      value
    ) : (
      <span style={{ color: "red" }}>--</span>
    );
  };

  const displayDate = (date) => {
    return date ? (
      new Date(date).toLocaleDateString("de-DE")
    ) : (
      <span style={{ color: "red" }}>--</span>
    );
  };

  // دالة لعرض نعم/لا أو X حمراء لو مش موجود

  const handleSendFeedBack = async (event) => {
    event.preventDefault();
    setloading(true);

    await dispatch(
      CreateFeedBack(
        { rightEyeFeedback, leftEyeFeedback },
        patientId, // ✅ زيادة
        reportId,
      ),
    );

    setloading(false);
    setFeedbackSent(true);
  };

  const res = useSelector((state) => state.alluser.feedback);
  console.log("Feedback Response:", res);

  useEffect(() => {
    if (feedbackSent) {
      if (res && res?.data?.message === "Feedback submitted successfully") {
        notify(t("examination.feedback_added_successfully"), "success");
      } else {
        notify(t("examination.feedback_add_failed"), "warn");
      }

      setFeedbackSent(false);
    }
  }, [feedbackSent, res, t]);

  const doctor_Name = `${userFromStorage.firstName} ${userFromStorage.lastName}`;
  const doctor_Address = `${userFromStorage.state},${userFromStorage.city},${userFromStorage.fullAddress}`;

  return (
    <>
      <Header />
      <NavBar className="no-print" />
      <Container
        ref={reportRef}
        className="report-content mt-5 mb-5 p-4 border rounded shadow bg-light"
      >
        <div
          className="d-flex justify-content-between align-items-center flex-wrap"
          style={{
            padding: "10px 20px",
            borderBottom: "2px solid #ccc",
            marginBottom: "20px",
          }}
        >
          {/* Optician Info - left */}
          <div style={{ fontSize: "0.8rem", textAlign: "left" }}>
            <div>
              <strong>{t("examination.doctorLabel")}</strong> {doctor_Name}
            </div>
            <div>
              <strong>{t("examination.addressLabel")}:</strong> {doctor_Address}
            </div>
          </div>

          {/* Title - center */}
          <div className="mx-auto text-center">
            <h2 style={{ fontWeight: "bold", margin: 0 }}>
              {t("examination.patient_eye_examination_report")}
            </h2>
          </div>
        </div>

        {/* Patient Info */}
        <Card className="mb-4 shadow rounded-2">
          <Card.Header className="custom-card-header">
            {t("examination.patient_information")}
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={4}>
                <div className="mb-2">
                  <strong>{t("examination.name")}:</strong>{" "}
                  {Report?.patient?.firstName || Report?.patient?.lastName ? (
                    <>
                      {Report?.patient?.firstName || (
                        <span style={{ color: "red" }}>---</span>
                      )}{" "}
                      {Report?.patient?.lastName || (
                        <span style={{ color: "red" }}>---</span>
                      )}
                    </>
                  ) : (
                    <span style={{ color: "red" }}>---</span>
                  )}
                </div>
                <div className="mb-2">
                  <strong>{t("examination.salutation")}:</strong>{" "}
                  {Report?.patient?.salutation ? (
                    t(`examination.salutations.${Report?.patient?.salutation}`)
                  ) : (
                    <span style={{ color: "red" }}>---</span>
                  )}
                </div>
                <div className="mb-2">
                  <strong>{t("examination.ethnicity")}:</strong>{" "}
                  {Report?.patient?.ethnicity ? (
                    t(
                      `examination.ethnicityOptions.${Report?.patient?.ethnicity}`,
                    )
                  ) : (
                    <span style={{ color: "red" }}>---</span>
                  )}
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-2">
                  <strong>{t("examination.date_of_birth")}:</strong>{" "}
                  {Report?.patient?.dateOfBirth ? (
                    displayDate(Report.patient.dateOfBirth)
                  ) : (
                    <span style={{ color: "red" }}>---</span>
                  )}
                </div>
                <div className="mb-2">
                  <strong>{t("examination.date_of_examination")}:</strong>{" "}
                  {new Date(Report?.createdAt).toLocaleDateString("de-DE")}
                </div>
                <div className="mb-2">
                  <strong>{t("examination.nextVisitDate")}:</strong>{" "}
                  {Report?.nextVisitDate ? (
                    displayDate(Report.nextVisitDate)
                  ) : (
                    <span style={{ color: "red" }}>---</span>
                  )}
                </div>
              </Col>
              <Col
                md={4}
                className="d-flex align-items-center justify-content-center"
              >
                {Report?.patient?.patientId ? (
                  <Barcode
                    value={Report.patient.patientId.toString()}
                    height={60}
                    width={2}
                    fontSize={14}
                  />
                ) : (
                  <span style={{ color: "red" }}>---</span>
                )}
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Card className="avoid-break mb-4">
          <Card.Header className="custom-card-header">
            {t("examination.medical_history")}
          </Card.Header>
          <Card.Body>
            <ListGroup>
              {Report?.history?.medical?.map((disease, idx) => (
                <ListGroup.Item key={idx}>
                  <div className="d-flex flex-column">
                    <div className="d-flex justify-content-between">
                      <strong>
                        {t(
                          `examination.medicalHistory.values.${disease.name}`,
                          {
                            defaultValue: disease.name,
                          },
                        )}
                      </strong>
                      <div className="ms-3">
                        <span>
                          <strong>
                            {t("examination.medicalHistory.hasCondition")}:
                          </strong>{" "}
                          {t(
                            `examination.medicalHistory.values.${
                              disease.hasCondition ? "Yes" : "No"
                            }`,
                          )}
                        </span>
                        <span className="ms-3">
                          <strong>
                            {t("examination.medicalHistory.appliesTo")}:
                          </strong>{" "}
                          {t(
                            `examination.medicalHistory.values.${disease.appliesTo}`,
                          )}
                        </span>
                      </div>
                    </div>

                    {/* ✅ عرض التفاصيل الإضافية لو المرض هو Diabetes M. */}
                    {disease.name === "Diabetes M." && (
                      <div className="d-flex flex-wrap mt-2">
                        <span className="me-3">
                          <strong>
                            {t("examination.medicalHistory.diabetes.sinceWhen")}
                            :
                          </strong>{" "}
                          {disease.sinceWhen ? (
                            disease.sinceWhen
                          ) : (
                            <span style={{ color: "red" }}>---</span>
                          )}
                        </span>

                        <span className="me-3">
                          <strong>
                            {t("examination.medicalHistory.diabetes.hba1cDate")}
                            :
                          </strong>{" "}
                          {disease.hba1cDate ? (
                            new Date(disease.hba1cDate).toLocaleDateString(
                              "de-DE",
                            )
                          ) : (
                            <span style={{ color: "red" }}>---</span>
                          )}
                        </span>

                        <span className="me-3">
                          <strong>
                            {t(
                              "examination.medicalHistory.diabetes.hba1cValue",
                            )}
                            :
                          </strong>{" "}
                          {disease.hba1cValue ? (
                            disease.hba1cValue
                          ) : (
                            <span style={{ color: "red" }}>---</span>
                          )}
                        </span>

                        <span className="me-3">
                          <strong>
                            {t("examination.medicalHistory.diabetes.treatment")}
                            :
                          </strong>{" "}
                          {disease.diabetesTreatment ? (
                            disease.diabetesTreatment
                          ) : (
                            <span style={{ color: "red" }}>---</span>
                          )}
                        </span>
                      </div>
                    )}
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Card.Body>
        </Card>

        <Card className="avoid-break mb-4">
          <Card.Header className="custom-card-header">
            {t("examination.eye_history")}
          </Card.Header>
          <Card.Body>
            <ListGroup>
              {Report?.history?.eye?.map((disease, idx) => (
                <ListGroup.Item key={idx}>
                  <div className="d-flex justify-content-between">
                    <strong>
                      {t(`examination.medicalHistory.values.${disease.name}`, {
                        defaultValue: disease.name,
                      })}
                    </strong>
                    <div className="ms-3">
                      <span>
                        <strong>
                          {t("examination.medicalHistory.hasCondition")}:
                        </strong>{" "}
                        {t(
                          `examination.medicalHistory.values.${disease.hasCondition ? "Yes" : "No"}`,
                        )}
                      </span>
                      <span className="ms-3">
                        <strong>
                          {t("examination.medicalHistory.appliesTo")}:
                        </strong>{" "}
                        {t(
                          `examination.medicalHistory.values.${disease.appliesTo}`,
                        )}
                      </span>
                    </div>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Card.Body>
        </Card>

        <Card className="avoid-break mb-4">
          <Card.Header className="custom-card-header">
            {t("examination.right_eye_examination_analysis")}
          </Card.Header>

          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">{t("examination.right_eye")}</h5>
              {Report?.eyeExamination?.rightEye?.imageCaptureDate && (
                <span className="text-muted">
                  {t("examination.image_capture_date")}{" "}
                  {new Date(
                    Report.eyeExamination.rightEye.imageCaptureDate,
                  ).toLocaleDateString("de-DE")}
                </span>
              )}
            </div>

            <>
              {Report?.eyeExamination?.rightEye?.images?.length > 0 ? (
                (() => {
                  // parse modelResults.rightEye JSON string - مرة واحدة برا مش جوه loop
                  let rightEyeResults = {};
                  try {
                    rightEyeResults = JSON.parse(
                      Report.modelResults?.rightEye || "{}",
                    );
                  } catch (err) {
                    console.error(
                      "Invalid JSON in modelResults.rightEye:",
                      err,
                    );
                    rightEyeResults = {}; // default آمن لو الـ parse فشل
                  }

                  const heatmapLink = rightEyeResults[
                    "Main Eye Disease (8 Classes)"
                  ]?.heatmap_path
                    ? `${API_BASE_URL}/heatmaps/${rightEyeResults[
                        "Main Eye Disease (8 Classes)"
                      ].heatmap_path
                        .split("/")
                        .pop()}`
                    : null;

                  // ⚠️ FIX: images دلوقتي array of { url, modality } objects مش strings،
                  // فلازم نستخرج الـ url بدل ما نستخدم الـ object نفسه كـ src.
                  // بنفضّل صورة الـ COLOR كمعاينة، ولو مش موجودة ناخد أول صورة.
                  const rightEyeImages = Report.eyeExamination.rightEye.images;
                  const colorImageObj =
                    rightEyeImages.find((img) => img.modality === "COLOR") ||
                    rightEyeImages[0];
                  const colorImageUrl = colorImageObj?.url;

                  // ✅ NEW: نفضّل الصور بعد المحاذاة (alignedImages) لو موجودة، عشان
                  // الـ Layer View يعرض صور متطابقة فعليًا فوق بعض. لو مفيش (مثلاً
                  // المحاذاة فشلت)، نرجع للصور الأصلية عادي - الـ viewer بيتعامل
                  // مع الحالتين.
                  const imagesForLayerView =
                    Report.eyeExamination.rightEye.alignedImages?.length > 0
                      ? Report.eyeExamination.rightEye.alignedImages
                      : Report.eyeExamination.rightEye.images;

                  return (
                    <div className="mb-4">
                      <div
                        style={{
                          position: "relative",
                          cursor: "pointer",
                          width: "160px",
                        }}
                      >
                        <PrivateImage
                          src={colorImageUrl}
                          crossOrigin="anonymous"
                          loading="lazy"
                          alt={`${t("reportdata.rightEye.header")}`}
                          style={{
                            width: "160px",
                            height: "160px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            border: "1px solid #ccc",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            window.open(
                              `/view-dicom?images=${encodeURIComponent(
                                JSON.stringify(imagesForLayerView),
                              )}&type=image`,
                              "_blank",
                            )
                          }
                        />

                        {heatmapLink && (
                          <Badge
                            bg="light"
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation(); // يمنع فتح الصورة العادية
                              setSelectedHeatmap(heatmapLink);
                            }}
                          >
                            <Fire size={14} /> {/* أيقونة Heatmap */}
                          </Badge>
                        )}
                      </div>
                    </div>
                  );
                })()
              ) : (
                <p>{t("reportdata.rightEye.noImages")}</p>
              )}

              {/* Modal لعرض الصورة العادية */}
              <Modal
                show={!!selectedImage}
                onHide={() => setSelectedImage(null)}
                centered
                size="lg"
              >
                <Modal.Header closeButton>
                  <Modal.Title>{t("examination.image_preview")}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                  <PrivateImage
                    src={selectedImage}
                    alt="Preview"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "80vh",
                      borderRadius: "8px",
                    }}
                  />
                </Modal.Body>
              </Modal>

              {/* Modal لعرض الهيت ماب */}
              <Modal
                show={!!selectedHeatmap}
                onHide={() => setSelectedHeatmap(null)}
                centered
                size="lg"
              >
                <Modal.Header closeButton>
                  <Modal.Title>Heatmap Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                  <PrivateImage
                    src={selectedHeatmap}
                    alt="Heatmap Preview"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "80vh",
                      borderRadius: "8px",
                    }}
                  />
                </Modal.Body>
              </Modal>
              {Report?.eyeExamination?.rightEye?.dicom?.length > 0 && (
                <div className="mt-3 no-print d-flex gap-2">
                  {Report.eyeExamination.rightEye.dicom.map((dicomUrl, idx) => (
                    <DicomThumbnail
                      key={idx}
                      dicomUrl={dicomUrl}
                      size={56}
                      title={t("reportdata.rightEye.viewDicom")}
                      onClick={() =>
                        window.open(
                          `/view-dicom?dicomUrl=${encodeURIComponent(dicomUrl)}`,
                          "_blank",
                        )
                      }
                    />
                  ))}
                </div>
              )}
            </>
            <Row>
              <Col>
                <strong>{t("examination.visus_cc")}</strong>{" "}
                {displayValue(Report?.eyeExamination?.rightEye?.visusCC)}
              </Col>
              <Col>
                <strong>{t("examination.previous_value")}</strong>{" "}
                {displayValue(Report?.eyeExamination?.rightEye?.previousValue)}
              </Col>
              <Col>
                <strong>{t("examination.since")}</strong>{" "}
                {displayDate(Report?.eyeExamination?.rightEye?.since)}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <strong>{t("examination.sphere")}</strong>{" "}
                {displayValue(Report?.eyeExamination?.rightEye?.sphere)}
              </Col>
              <Col>
                <strong>{t("examination.cylinder")}</strong>{" "}
                {displayValue(Report?.eyeExamination?.rightEye?.cylinder)}
              </Col>
              <Col>
                <strong>{t("examination.axis")}</strong>{" "}
                {displayValue(Report?.eyeExamination?.rightEye?.axis)}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <strong>{t("examination.intraocular_pressure")}</strong>{" "}
                {displayValue(
                  Report?.eyeExamination?.rightEye?.intraocularPressure,
                )}
              </Col>
              <Col>
                <strong>{t("examination.corneal_thickness")}</strong>{" "}
                {displayValue(
                  Report?.eyeExamination?.rightEye?.cornealThickness,
                )}
              </Col>
              <Col>
                <strong>{t("examination.chamber_angle")}</strong>{" "}
                {Report?.eyeExamination?.rightEye?.chamberAngle ? (
                  t(
                    `examination.commonValues.${Report?.eyeExamination?.rightEye?.chamberAngle}`,
                  )
                ) : (
                  <span style={{ color: "red" }}>--</span>
                )}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <strong>{t("examination.amsler_test_abnormal")}</strong>{" "}
                {Report?.eyeExamination?.rightEye?.amslerTest}
              </Col>
            </Row>

            <div className="mt-4">
              {Report?.modelResults?.rightEye ? (
                (() => {
                  const rightData = JSON.parse(Report.modelResults.rightEye);
                  const isImageQualityBad =
                    rightData.image_quality?.status !== "Adequate";

                  const filteredDiseases = Object.entries(rightData).filter(
                    ([key, value]) =>
                      key !== "image_quality" &&
                      key !== "eye_side" &&
                      value.status === "Detected",
                  );

                  return (
                    <>
                      <p>
                        <strong>{t("examination.image_quality")} : </strong>
                        <span
                          style={{
                            color: isImageQualityBad ? "red" : "green",
                          }}
                        >
                          {isImageQualityBad
                            ? t("examination.image_quality_bad")
                            : t("examination.image_quality_good")}
                        </span>
                      </p>
                      {filteredDiseases.length > 0 ? (
                        <table className="table table-bordered mt-2">
                          <thead>
                            <tr>
                              <th>{t("examination.disease")}</th>
                              <th>{t("examination.confidence_percent")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredDiseases.map(([key, value]) => (
                              <tr key={key}>
                                <td>{key}</td>
                                <td>
                                  <span className="badge bg-info text-dark">
                                    {value.confidence ?? "N/A"}%
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <p>{t("examination.no_detected_diseases_right_eye")}</p>
                      )}

                      {isImageQualityBad && (
                        <div className="alert alert-warning mt-3">
                          <strong>{t("examination.bad_image_quality")}</strong>
                          <br />
                          {t("examination.bad_image_quality_details")}
                        </div>
                      )}
                    </>
                  );
                })()
              ) : (
                <p>{t("examination.no_prediction_data_right_eye")}</p>
              )}
            </div>
            {(Report?.modelResults?.rightEye ||
              Report?.eyeExamination?.rightEye?.images?.length > 0) && (
              <Card className="mt-4 border-primary no-print">
                <Card.Header
                  onClick={() => setShowRightEyeFeedback(!showRightEyeFeedback)}
                  className="bg-primary text-white d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                >
                  <span>{t("examination.doctor_feedback_right_eye")}</span>
                  {showRightEyeFeedback ? <ChevronUp /> : <ChevronDown />}
                </Card.Header>

                {showRightEyeFeedback && (
                  <Card.Body>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <strong>
                          {t("examination.ai_prediction_correct")}
                        </strong>
                      </Form.Label>
                      <Form.Select
                        value={rightEyeFeedback.aiPredictionCorrect}
                        onChange={(e) =>
                          setRightEyeFeedback({
                            ...rightEyeFeedback,
                            aiPredictionCorrect: e.target.value,
                          })
                        }
                      >
                        <option value="">{t("examination.select")}</option>
                        <option value="correct">
                          {t("examination.correct")}
                        </option>
                        <option value="incorrect">
                          {t("examination.incorrect")}
                        </option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>
                        <strong>{t("examination.comment")}</strong>
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        value={rightEyeFeedback.comment}
                        onChange={(e) =>
                          setRightEyeFeedback({
                            ...rightEyeFeedback,
                            comment: e.target.value,
                          })
                        }
                        placeholder={t(
                          "examination.enter_right_eye_prediction_opinion",
                        )}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>
                        <strong>{t("examination.diagnosis")}</strong>
                      </Form.Label>
                      <Select
                        options={diagnosisOptions}
                        onChange={(selected) =>
                          setRightEyeFeedback({
                            ...rightEyeFeedback,
                            diagnosis: selected ? selected.value : "",
                          })
                        }
                        placeholder={t("examination.search_select_diagnosis")}
                        isClearable
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>
                        <strong>
                          {t("examination.right_eye_recommended_action")}
                        </strong>
                      </Form.Label>
                      <Form.Select
                        value={rightEyeFeedback.recommendedAction}
                        onChange={(e) =>
                          setRightEyeFeedback({
                            ...rightEyeFeedback,
                            recommendedAction: e.target.value,
                          })
                        }
                      >
                        <option value="">
                          {t("examination.select_an_action")}
                        </option>
                        <option value="Refer to Ophthalmologist">
                          {t("examination.refer_to_ophthalmologist")}
                        </option>
                        <option value="Refer to other physicians">
                          {t("examination.refer_to_other_physicians")}
                        </option>
                        <option value="Follow-up in 1 year">
                          {t("examination.follow_up_in_1_year")}
                        </option>
                        <option value="No follow-up required">
                          {t("examination.no_follow_up_required")}
                        </option>
                      </Form.Select>
                    </Form.Group>

                    <Button
                      variant="primary"
                      onClick={(e) => handleSendFeedBack(e)}
                    >
                      {t("examination.submit_right_eye_feedback")}
                    </Button>
                  </Card.Body>
                )}
              </Card>
            )}
          </Card.Body>
        </Card>

        <Card className="avoid-break mb-4">
          <Card.Header className="custom-card-header">
            {t("examination.left_eye_examination_analysis")}
          </Card.Header>

          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">{t("examination.left_eye")}</h5>
              {Report?.eyeExamination?.leftEye?.imageCaptureDate && (
                <span className="text-muted">
                  {t("examination.image_capture_date")}{" "}
                  {new Date(
                    Report.eyeExamination.leftEye.imageCaptureDate,
                  ).toLocaleDateString("de-DE")}
                </span>
              )}
            </div>

            {Report?.eyeExamination?.leftEye?.images?.length > 0 ? (
              (() => {
                // parse modelResults.leftEye JSON string - مرة واحدة برا مش جوه loop
                let leftEyeResults = {};
                try {
                  leftEyeResults = JSON.parse(
                    Report.modelResults?.leftEye || "{}",
                  );
                } catch (err) {
                  console.error("Invalid JSON in modelResults.leftEye:", err);
                  leftEyeResults = {}; // default آمن لو الـ parse فشل
                }

                const heatmapLink = leftEyeResults[
                  "Main Eye Disease (8 Classes)"
                ]?.heatmap_path
                  ? `${API_BASE_URL}/heatmaps/${leftEyeResults[
                      "Main Eye Disease (8 Classes)"
                    ].heatmap_path
                      .split("/")
                      .pop()}`
                  : null;

                // ⚠️ FIX: images دلوقتي array of { url, modality } objects مش strings،
                // فلازم نستخرج الـ url بدل ما نستخدم الـ object نفسه كـ src.
                // بنفضّل صورة الـ COLOR كمعاينة، ولو مش موجودة ناخد أول صورة.
                const leftEyeImages = Report.eyeExamination.leftEye.images;
                const colorImageObj =
                  leftEyeImages.find((img) => img.modality === "COLOR") ||
                  leftEyeImages[0];
                const colorImageUrl = colorImageObj?.url;

                // ✅ NEW: نفضّل الصور بعد المحاذاة (alignedImages) لو موجودة، عشان
                // الـ Layer View يعرض صور متطابقة فعليًا فوق بعض. لو مفيش (مثلاً
                // المحاذاة فشلت)، نرجع للصور الأصلية عادي - الـ viewer بيتعامل
                // مع الحالتين.
                const imagesForLayerView =
                  Report.eyeExamination.leftEye.alignedImages?.length > 0
                    ? Report.eyeExamination.leftEye.alignedImages
                    : Report.eyeExamination.leftEye.images;

                return (
                  <div className="mb-4">
                    <div
                      style={{
                        position: "relative",
                        cursor: "pointer",
                        width: "160px",
                      }}
                    >
                      <PrivateImage
                        src={colorImageUrl}
                        crossOrigin="anonymous"
                        loading="lazy"
                        alt={`${t("reportdata.leftEye.header")}`}
                        style={{
                          width: "160px",
                          height: "160px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          border: "1px solid #ccc",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          window.open(
                            `/view-dicom?images=${encodeURIComponent(
                              JSON.stringify(imagesForLayerView),
                            )}&type=image`,
                            "_blank",
                          )
                        }
                      />

                      {heatmapLink && (
                        <Badge
                          bg="light"
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.stopPropagation(); // يمنع فتح الصورة العادية
                            setSelectedHeatmap(heatmapLink);
                          }}
                        >
                          <Fire size={14} /> {/* أيقونة Heatmap */}
                        </Badge>
                      )}
                    </div>
                  </div>
                );
              })()
            ) : (
              <p>{t("reportdata.leftEye.noImages")}</p>
            )}
            <Modal
              show={!!selectedImage}
              onHide={() => setSelectedImage(null)}
              centered
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  {t("reportdata.leftEye.imagePreview")}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="text-center">
                <PrivateImage
                  src={selectedImage}
                  alt="Preview"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "80vh",
                    borderRadius: "8px",
                  }}
                />
              </Modal.Body>
            </Modal>
            <Modal
              show={!!selectedHeatmap}
              onHide={() => setSelectedHeatmap(null)}
              centered
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>Heatmap Preview</Modal.Title>
              </Modal.Header>
              <Modal.Body className="text-center">
                <PrivateImage
                  src={selectedHeatmap}
                  alt="Heatmap Preview"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "80vh",
                    borderRadius: "8px",
                  }}
                />
              </Modal.Body>
            </Modal>
            {Report?.eyeExamination?.leftEye?.dicom?.length > 0 && (
              <div className="mt-3 no-print d-flex gap-2">
                {Report.eyeExamination.leftEye.dicom.map((dicomUrl, idx) => (
                  <DicomThumbnail
                    key={idx}
                    dicomUrl={dicomUrl}
                    size={56}
                    title={t("reportdata.leftEye.viewDicom")}
                    onClick={() =>
                      window.open(
                        `/view-dicom?dicomUrl=${encodeURIComponent(dicomUrl)}`,
                        "_blank",
                      )
                    }
                  />
                ))}
              </div>
            )}
            <Row>
              <Col>
                <strong>{t("examination.visus_cc")}</strong>{" "}
                {displayValue(Report?.eyeExamination?.leftEye?.visusCC)}
              </Col>
              <Col>
                <strong>{t("examination.previous_value")}</strong>{" "}
                {displayValue(Report?.eyeExamination?.leftEye?.previousValue)}
              </Col>
              <Col>
                <strong>{t("examination.since")}</strong>{" "}
                {displayDate(Report?.eyeExamination?.leftEye?.since)}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <strong>{t("examination.sphere")}</strong>{" "}
                {displayValue(Report?.eyeExamination?.leftEye?.sphere)}
              </Col>
              <Col>
                <strong>{t("examination.cylinder")}</strong>{" "}
                {displayValue(Report?.eyeExamination?.leftEye?.cylinder)}
              </Col>
              <Col>
                <strong>{t("examination.axis")}</strong>{" "}
                {displayValue(Report?.eyeExamination?.leftEye?.axis)}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <strong>{t("examination.intraocular_pressure")}</strong>{" "}
                {displayValue(
                  Report?.eyeExamination?.leftEye?.intraocularPressure,
                )}
              </Col>
              <Col>
                <strong>{t("examination.corneal_thickness")}</strong>{" "}
                {displayValue(
                  Report?.eyeExamination?.leftEye?.cornealThickness,
                )}
              </Col>
              <Col>
                <strong>{t("examination.chamber_angle")}</strong>{" "}
                {Report?.eyeExamination?.leftEye?.chamberAngle ? (
                  t(
                    `examination.commonValues.${Report?.eyeExamination?.leftEye?.chamberAngle}`,
                  )
                ) : (
                  <span style={{ color: "red" }}>--</span>
                )}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <strong>{t("examination.amsler_test_abnormal")}</strong>{" "}
                {Report?.eyeExamination?.leftEye?.amslerTest}
              </Col>
            </Row>

            <div className="mt-4">
              {Report?.modelResults?.leftEye ? (
                (() => {
                  const leftData = JSON.parse(Report.modelResults.leftEye);
                  const isImageQualityBad =
                    leftData.image_quality?.status !== "Adequate";

                  const filteredDiseases = Object.entries(leftData).filter(
                    ([key, value]) =>
                      key !== "image_quality" &&
                      key !== "eye_side" &&
                      value.status === "Detected",
                  );

                  return (
                    <>
                      <p>
                        <strong>{t("examination.image_quality")} : </strong>
                        <span
                          style={{
                            color: isImageQualityBad ? "red" : "green",
                          }}
                        >
                          {isImageQualityBad
                            ? t("examination.image_quality_bad")
                            : t("examination.image_quality_good")}
                        </span>
                      </p>
                      {filteredDiseases.length > 0 ? (
                        <table className="table table-bordered mt-2">
                          <thead>
                            <tr>
                              <th>{t("examination.disease")}</th>
                              <th>{t("examination.confidence_percent")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredDiseases.map(([key, value]) => (
                              <tr key={key}>
                                <td>{key}</td>
                                <td>
                                  <span className="badge bg-info text-dark">
                                    {value.confidence ?? "N/A"}%
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <p>{t("examination.no_detected_diseases_left_eye")}</p>
                      )}

                      {isImageQualityBad && (
                        <div className="alert alert-warning mt-3">
                          <strong>{t("examination.bad_image_quality")}</strong>
                          <br />
                          {t("examination.bad_image_quality_details")}
                        </div>
                      )}
                    </>
                  );
                })()
              ) : (
                <p>{t("examination.no_prediction_data_left_eye")}</p>
              )}
            </div>
            {(Report?.modelResults?.leftEye ||
              Report?.eyeExamination?.leftEye?.images?.length > 0) && (
              <Card className="mt-4 border-primary no-print">
                <Card.Header
                  onClick={() => setShowLeftEyeFeedback(!showLeftEyeFeedback)}
                  className="bg-primary text-white d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                >
                  <span>{t("examination.doctor_feedback_left_eye")}</span>
                  {showLeftEyeFeedback ? <ChevronUp /> : <ChevronDown />}
                </Card.Header>

                {showLeftEyeFeedback && (
                  <Card.Body>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <strong>
                          {t("examination.ai_prediction_correct")}
                        </strong>
                      </Form.Label>
                      <Form.Select
                        value={leftEyeFeedback.aiPredictionCorrect}
                        onChange={(e) =>
                          setLeftEyeFeedback({
                            ...leftEyeFeedback,
                            aiPredictionCorrect: e.target.value,
                          })
                        }
                      >
                        <option value="">{t("examination.select")}</option>
                        <option value="correct">
                          {t("examination.correct")}
                        </option>
                        <option value="incorrect">
                          {t("examination.incorrect")}
                        </option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>
                        <strong>{t("examination.comment")}</strong>
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        value={leftEyeFeedback.comment}
                        onChange={(e) =>
                          setLeftEyeFeedback({
                            ...leftEyeFeedback,
                            comment: e.target.value,
                          })
                        }
                        placeholder={t(
                          "examination.enter_left_eye_prediction_opinion",
                        )}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>
                        <strong>{t("examination.diagnosis")}</strong>
                      </Form.Label>
                      <Select
                        options={diagnosisOptions}
                        onChange={(selected) =>
                          setLeftEyeFeedback({
                            ...leftEyeFeedback,
                            diagnosis: selected ? selected.value : "",
                          })
                        }
                        placeholder={t("examination.search_select_diagnosis")}
                        isClearable
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>
                        <strong>{t("examination.recommended_action")}</strong>
                      </Form.Label>
                      <Form.Select
                        value={leftEyeFeedback.recommendedAction}
                        onChange={(e) =>
                          setLeftEyeFeedback({
                            ...leftEyeFeedback,
                            recommendedAction: e.target.value,
                          })
                        }
                      >
                        <option value="">
                          {t("examination.select_an_action")}
                        </option>
                        <option value="Refer to Ophthalmologist">
                          {t("examination.refer_to_ophthalmologist")}
                        </option>
                        <option value="Refer to other physicians">
                          {t("examination.refer_to_other_physicians")}
                        </option>
                        <option value="Follow-up in 1 year">
                          {t("examination.follow_up_in_1_year")}
                        </option>
                        <option value="No follow-up required">
                          {t("examination.no_follow_up_required")}
                        </option>
                      </Form.Select>
                    </Form.Group>

                    <Button
                      variant="primary"
                      onClick={(e) => handleSendFeedBack(e)}
                    >
                      {t("examination.submit_left_eye_feedback")}
                    </Button>
                  </Card.Body>
                )}
              </Card>
            )}
          </Card.Body>
        </Card>

        <div className="d-flex justify-content-center mt-4 gap-3">
          <Button onClick={handlePrint} variant="danger" className="no-print">
            {t("examination.download_report")}
          </Button>
        </div>
        <div className="d-flex justify-content-end mt-4">
          <span style={{ fontStyle: "italic" }}>
            {t("examination.optician")} {opticianName}
          </span>
        </div>
      </Container>

      <Footer />
    </>
  );
};

export default PatientReport;
